import { validateCTPS } from 'utils/validation/validators'

type ValidateCTPSOnCustomFormParams = {
  ctps: string
  isRequired?: boolean
}

export default function validateCTPSOnCustomForm({ ctps, isRequired }: ValidateCTPSOnCustomFormParams) {
  let error = ''
  if (isRequired && !ctps) {
    error = 'Este campo é obrigatório'
  }
  if (ctps && !validateCTPS(ctps)) {
    error = 'Este CTPS está incorreto.'
  }
  return error
}
